import { createSortable } from '../../feature/sortable'
import { createHeaderTips } from '../../feature/tips'
import { createHeaderFilter } from '../../feature/filter'
import { createCollapse } from '../../feature/collapse'
import '../../../style/header-cell-options.scss'

const Sortable = createSortable()
const Tips = createHeaderTips()
const Filter = createHeaderFilter()
const Collapse = createCollapse()

export function createHeaderCellOptions () {
  return {
    name: 'headerCellOptions',
    functional: true,
    render (_, context) {
      const props = context.props
      const {
        column,
        store,
        handleSortChange,
        setHeaderPopoverAttrs,
        changeHeaderPopoverVisibleStatus,
        getHeaderPopoverAttrs
      } = props
      const {
        sortable,
        tipsOptions = {},
        tipsContent,
        tipsContentRender,
        filters,
        collapsed,
        collapseKeys,
      } = column
      if (!sortable && !tipsContent && !filters && !tipsContentRender && !collapseKeys) {
        return null
      }
      const handleCollapsed = () => {
        if (store.isReadyDraging(column)) return
        store.changeCollapseKeys(column, true)
      }

      const sortOrder = store.states.sortMap.prop === column.key ? store.states.sortMap.order : ''

      return <div class="header-cell-options">
        {
          sortable ? <Sortable sortOrder={sortOrder} handleSortChange={() => handleSortChange(column)}></Sortable> : null
        }
        {
          tipsContent || tipsContentRender ? <Tips tipsOptions={tipsOptions} column={column}>
            {
              tipsContentRender ? tipsContentRender(_, column) : tipsContent
            }
          </Tips> : null
        }
        {
          filters ? <Filter
            ref="filter"
            column={column}
            filterChange={store.filterChange}
            store={store}
            setHeaderPopoverAttrs={setHeaderPopoverAttrs}
            changeHeaderPopoverVisibleStatus={changeHeaderPopoverVisibleStatus}
            getHeaderPopoverAttrs={getHeaderPopoverAttrs}
          ></Filter> : null
        }
        {
          collapseKeys ? <Collapse collapsed={collapsed} handleCollapsed={handleCollapsed}></Collapse> : null
        }
      </div>
    },
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/header/header-thead/cell-options.js